import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Label, Modal } from 'reactstrap';
import { createSelector } from 'reselect';
import VerifylinkResendLayout from '../../../../components/Lystface/Helper/Verification/VerifylinkResendLayout';
import CommonInputField from './CommonInputField';
import form_input_patterns from '../../../../constants/form_input_patterns';
import { useFormik } from 'formik';
import * as Yup from "yup"
import form_messages from '../../../../constants/form_messages';
import Secure from '../../../../constants/secure/Secure';
import { getMinMaxForPhoneCode, isNotNullOrUndefined, maskEmail, maskPhoneNumber } from '../../../../common/functions';
import { resendOtp, resetResendOtpResponseMsg, sendEmail, verifyCurrentPassword } from '../../../../store/menu/application/actions';
import { CustomToast } from '../../../../components/Lystface/Common/CustomToast';



export default function Content() {

    const selectAccountSetting = state => state.Application;
    const responseAccountSetting = createSelector(selectAccountSetting, account => ({
        phone: account.getAccountData?.data?.phone,
        email: account.getAccountData?.data?.cmp_email,
        cmp_phone_code: account.getAccountData?.data?.cmp_phone_code,
        is_phone_verified: account.getAccountData?.data?.is_phone_verified,
        is_email_verified: account.getAccountData?.data?.is_email_verified,
        cid: account.getAccountData?.data?.cid,


    }))
    const {
        phone,
        email,
        cmp_phone_code,
        is_email_verified,
        is_phone_verified,
        cid
    } = useSelector(responseAccountSetting);

    const [popupDetails, setPopupDetails] = useState({ open: false })
    const [applicationStatus, setApplicationStatus] = useState("manage")
    const ApplicationState = useSelector(state => state.Application);
    const { verifyCurrentPswd: { loading: currentPasswordLoading, error: currentPasswordError, responseMessage: currentPasswordResponseMessage } } = ApplicationState
    const dispatch = useDispatch();
    const { sendEmail: { loading: sendEmailLoading, error: sendEmailError, responseMessage: senndEmailResponseMessage } } = ApplicationState
    const { resendOtp: { loading: sendOtpLoading, error: sendOtpError, responseMessage: senndOtpResponseMessage } } = ApplicationState





    useEffect(() => {
        if (!currentPasswordError && isNotNullOrUndefined(currentPasswordResponseMessage) && popupDetails.open) {
            EditEmailAndPassword(popupDetails?.from)
        }

    }, [currentPasswordError])

    useEffect(() => {
        if (isNotNullOrUndefined(senndEmailResponseMessage) || isNotNullOrUndefined(senndOtpResponseMessage)) {
            CustomToast({
                message: senndEmailResponseMessage ? senndEmailResponseMessage : senndOtpResponseMessage,
                status: sendEmailError || sendOtpError ? 'failure' : "success",
                closeToast: () => {
                    console.log('Toast closed');
                },
            })
            dispatch(resetResendOtpResponseMsg())
            setPopupDetails({ ...popupDetails, verifyPhone: false })

        }
    }, [senndEmailResponseMessage, senndOtpResponseMessage])

    useEffect(() => {
        if ((!sendEmailError && isNotNullOrUndefined(senndEmailResponseMessage)) || (!sendOtpError && isNotNullOrUndefined(senndOtpResponseMessage)) && (validationType?.values?.phone?.length > 0 ? popupDetails.open : popupDetails.verifyPhone)) {
            handleOpenVerifyPopup(popupDetails.open ? popupDetails?.from : "phone", popupDetails.verifyPhone ? "verify" : false)
        }

    }, [sendEmailError, sendOtpError])

    const handleOpenVerifyPopup = (from, verifyType) => {
        if (from === "phone") {
            setPopupDetails({
                open: true,
                from: from,
                title: "Verify your phone number",
                subtitle: <div>We've sent an OTP to the number ending with {validationType?.values?.dialCode || cmp_phone_code} {maskPhoneNumber(validationType?.values?.phone || phone)}. Please enter it below. <a onClick={() => {
                    if (verifyType === "verify") {
                        handleEditClick(from)
                    }
                    else {
                        EditEmailAndPassword(from);

                    }
                }}>Edit phone number</a></div>,
                checkboxContent: "I confirm that two-factor authentication will be linked to my new phone number.",
                isLogo: false,
                onlyVerify: verifyType === "verify" ? true : false
            })
        }
        else {
            setPopupDetails({
                open: true,
                from: from,
                title: "Verify your e-mail",
                subtitle: <div> We’ve sent a code to {maskEmail(validationType?.values?.email || email)}. Please enter it below. <a onClick={() => EditEmailAndPassword(from)}>Edit email</a></div>,
                checkboxContent: false,
                isLogo: false,
                onlyVerify: verifyType === "verify" ? true : false

            })
        }
    }



    const EditEmailAndPassword = (from) => {
        if (from === "phone") {
            setPopupDetails({
                open: true,
                type: 'edit',
                from: "phone",
                label: "Phone number",
                key: "phone",
                primaryButtonText: 'Verify phone', secondaryButtonText: 'Cancel', handleClickSecondaryButton: handleClickCancel, handleClickPrimaryButton: handleVerify
            })
        }
        else {
            setPopupDetails({
                open: true,
                type: 'edit',
                from: "email",
                label: "Email",
                key: "email",
                primaryButtonText: 'Verify email', secondaryButtonText: 'Cancel', handleClickSecondaryButton: handleClickCancel, handleClickPrimaryButton: handleVerify
            })
        }
    }

    const validationType = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
            currentPwd: "",
            cmpPhoneCode: "99",
            phone: "",
            dialCode: "+91",
        },
        validationSchema: Yup.object().shape({
            email: Yup.string()
                .test("email", form_messages.Signup.email.Invalid, function (value) {
                    let emailRegex
                    if (process.env.REACT_APP_NODE !== "prod") {
                        emailRegex = form_input_patterns.TESTING_EMAIL

                    }
                    else {
                        emailRegex = form_input_patterns.EMAIL

                    }
                    return emailRegex.test(value)
                })
                .max(255)
                .required(form_messages.Signup.businessemail.Required),
            pwd: Yup.string().required(form_messages.Signup.password.Required),
            cmpPhoneCode: Yup.string()
                .max(10)
                .required(form_messages.Common.REQUIRED),
            phone: Yup.string()
                .required(form_messages.Signup.phone.Required)
                .when('cmpPhoneCode', (cmpPhoneCode, schema) => {
                    const { min, max } = getMinMaxForPhoneCode(cmpPhoneCode[0]);
                    return schema
                        .min(min, form_messages.Signup.phone.INVALID)
                        .max(max, form_messages.Signup.phone.INVALID)
                })
                .test(
                    "is-not-negative",
                    form_messages.Signup.phone.NONNEGATIVE,
                    value => {
                        const numericValue = parseFloat(value)
                        return numericValue >= 0
                    }
                ),
        }),

    })

    const handleVerify = (from, validationType) => {
        if (from === "phone") {
            if (!validationType?.values?.phone) {
                setPopupDetails({ verifyPhone: true })
            }
            const payload = {
                login: false,
                cmp_phone_code: validationType?.values?.cmpPhoneCode || cid,
                cmp_phone: validationType?.values?.phone || phone,

            }
            dispatch(resendOtp(payload, "send"))


        }
        else {
            const payload = {
                email: validationType?.values?.email || email

            }
            dispatch(sendEmail(payload))

        }
    }

    const handleSubmitCurrentPswd = (from, validationType) => {
        dispatch(verifyCurrentPassword({ email: email, pwd: Secure.Encrypt(validationType?.values?.currentPwd) }))

    }

    const handleClickCancel = () => {
        setPopupDetails({ open: false })
        setApplicationStatus("manage")
        validationType.resetForm();

    }

    const handleEditClick = (from) => {
        validationType.resetForm();
        setApplicationStatus("edit")
        setPopupDetails({
            open: true,
            type: 'edit',
            from: from,
            label: "Current password",
            key: "currentPwd",
            primaryButtonText: 'Validate', secondaryButtonText: 'Cancel', handleClickSecondaryButton: handleClickCancel, handleClickPrimaryButton: handleSubmitCurrentPswd
        })
    }
    return (
        <>
            <div className={`app-form-fields-container-setting ${applicationStatus === "edit" ? `${popupDetails.from}` : ""}`}>

                <CommonInputField inputLabel="Email" inputValue={email} inputKey="email" handleEditClick={handleEditClick} applicationStatus={"manage"} handleVerify={handleVerify} validationType={validationType} verified={is_email_verified} isLoading={sendOtpLoading && popupDetails.verifyPhone} />
                <CommonInputField inputLabel="Phone number" inputValue={`${cmp_phone_code} ${phone}`} inputKey="phone" handleEditClick={handleEditClick} applicationStatus={"manage"} handleVerify={handleVerify} validationType={validationType} verified={is_phone_verified} isLoading={sendOtpLoading && popupDetails.verifyPhone} />

            </div >
            {
                popupDetails.open &&


                    popupDetails.type !== "edit" ?

                    <Modal isOpen={popupDetails.open} className={`popup-container ${popupDetails.type !== "edit" ? "settings-modal" : ""}`} >
                        <VerifylinkResendLayout title={popupDetails.title} isLogo={popupDetails.isLogo} message={popupDetails.subtitle} checkboxContent={popupDetails.checkboxContent} from={popupDetails.from} handleClose={handleClickCancel} email={validationType.values?.email || email} phone={validationType?.values?.phone || phone} cmp_phone_code={validationType?.values?.cmpPhoneCode || cid} dialCode={validationType?.values?.dialCode || cmp_phone_code} onlyVerify={popupDetails.onlyVerify} />



                    </Modal>
                    :
                    popupDetails.type === "edit" ?

                        <div className={`popup-container ${popupDetails.from === "email" ? "settings-modal-edit-email" : "settings-modal-edit-phone"}`}>
                            <CommonInputField inputLabel={popupDetails.label} inputValue={validationType.values[popupDetails?.key]} inputKey={popupDetails.key} validationType={validationType} handleEditClick={handleEditClick} handleVerify={handleVerify} applicationStatus={applicationStatus} from={popupDetails.from} isLoading={sendOtpLoading} />
                            <div className='save-card-btn'>
                                <button className='btn-cancel' type='button' onClick={() => {
                                    popupDetails.handleClickSecondaryButton();
                                }}>{popupDetails.secondaryButtonText}</button>
                                <button disabled={currentPasswordLoading || validationType.errors[popupDetails?.key]?.length > 0 || sendEmailLoading || (sendOtpLoading && popupDetails.from === "phone") || validationType?.values?.email === email || (validationType?.values?.cmpPhoneCode === cid && validationType?.values?.phone === phone)} className={`${validationType.values[popupDetails?.key]?.length === 0 || currentPasswordLoading || validationType.errors[popupDetails?.key]?.length > 0 || sendEmailLoading || sendOtpLoading || validationType?.values?.email === email || (validationType?.values?.cmpPhoneCode === cid && validationType?.values?.phone === phone) ? "btn-save me-0 button-disabled" : "btn-save me-0"}`} type='submit' onClick={(e) => {
                                    popupDetails.handleClickPrimaryButton(popupDetails?.from, validationType);
                                }}>{popupDetails.primaryButtonText}
                                    {(currentPasswordLoading || sendEmailLoading || (sendOtpLoading && popupDetails.from === "phone")) &&
                                        <div className="spinner-container spinner-border">
                                        </div>}
                                </button>
                            </div>
                        </div>
                        :
                        null





            }
        </>


    )
}
